import { Project } from '@bulthaup/api/db';
import { getProjectAmounts } from '@bulthaup/api/entities/budget';
import { Group, Stack, Text } from '@mantine/core';
import { Decimal } from 'decimal.js';

import { formatAmount } from '../../../../../utils/format';

export function ProjectsSummary({ projects }: { projects: Project[] }) {
  const grossTotalAmount = projects.reduce((acc, project) => {
    const gross = Object.values(getProjectAmounts(project).gross);
    const projectTotal = gross.reduce(
      (sum, val) => sum.add(val),
      new Decimal(0),
    );
    return acc.add(projectTotal);
  }, new Decimal(0));

  return (
    <Stack>
      <Group justify="space-between">
        <Text>Total général TTC:</Text>
        <Text fw={700}> {formatAmount(grossTotalAmount)}</Text>
      </Group>
    </Stack>
  );
}
